import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import App from './App';
import ChallengePage from './pages/ChallengePage';
import Challenges from './pages/Challenges';
import Leaderboard from './pages/Leaderboard';
import Signup from './components/Signup';
import Login from './components/Login';

const container = document.getElementById('root');
const root = createRoot(container);

function AppRouter() {
  const [user, setUser] = useState(null);  // State to manage the logged-in user

  return (
    <Router>
      <Routes>
        <Route path="/" element={<App user={user} />} /> {/* Pass user state to App */}
        <Route path="/challenges" element={<Challenges user={user} />} /> {/* Pass user to Challenges */}
        <Route path="/leaderboard" element={<Leaderboard user={user} />} />
        <Route path="/challenge/:id" element={<ChallengePage user={user} />} /> {/* Pass user to ChallengePage */}
        <Route path="/signup" element={<Signup setUser={setUser} />} />  {/* Pass setUser to Signup */}
        <Route path="/login" element={<Login setUser={setUser} />} />    {/* Pass setUser to Login */}
      </Routes>
    </Router>
  );
}

root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
